import { Component, OnInit, Input } from "@angular/core";
import { ScaleResult } from "app/shared/models/scale-result";
import { AssessmentResult } from "app/shared/models/assessment-result";
import { Variable } from "app/reports/models/variable";
import { Assessment } from "app/shared/models/assessment";
import { BaseReportItemComponent } from "app/reports/models/base-report-item-component";
import { IReportItemComponent } from "app/reports/models/i-report-item-component";

interface ScaleChart {
  scaleResult: ScaleResult
  , assessment: Assessment
}
@Component({
  selector: "app-scale-results-summary",
  templateUrl: "./scale-results-summary.component.html"
})
export class ScaleResultsSummaryComponent extends BaseReportItemComponent implements OnInit, IReportItemComponent {
  public charts: ScaleChart[];
  public mainChart: ScaleChart;

  private _scales_per_page: number;
  private _assessmentResult: AssessmentResult;
  private _scaleResults: ScaleResult[];
  private _assessmentResults: AssessmentResult[];
  private _resultByUid: Map<any, AssessmentResult>;
  private _title: string;
  private _description: string;

  private _sections: any[];


  get sections() {
    if (this._sections && this._sections.length) {
      return this._sections;
    }
    return [];
  }

  constructor() {
    super();
    this.charts = [];
    this._resultByUid = new Map<any, AssessmentResult>();
    this._sections = [];
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  getPrintClasses(section:{printHide?:boolean, printDisplayOnly?:boolean}) {
    let styles = {
      'd-print-none': section.printHide
      , 'd-none d-print-block': section.printDisplayOnly
      , 'section-page-break': !section.printHide
    };
    return styles;
  }

  getChartClasses(item:any) {
    if (item.chartSize) {
      let result = "p-" + item.chartSize + "-chart";
      return [result];
    }
    else {
      return ["p-small-chart"];
    }
  }

  public getAssessmentResult(uid: any): AssessmentResult {
    if (this._resultByUid.has(uid)) {
      return this._resultByUid.get(uid);
    }
    return null;
  }

  public getScaleResultItems(scaleResults: { assessmentUid: string, scaleId: string }[]) {
    if (!(scaleResults && scaleResults.length)) {
      return [];
    }

    return scaleResults.map(sr => this.getScaleResult(sr.assessmentUid, sr.scaleId));
  }

  public getScaleResult(uid: any, scaleId: string) {
    if (this._resultByUid.has(uid)) {
      return this._resultByUid.get(uid).getScaleResultByScaleId(scaleId);
    }
    return null;
  }

  getScaleResultLabels(uid: any, scaleId: string) {
    let result = this.getScaleResult(uid, scaleId);
    if (result) {
      return result.scale.ranges.map(r => r.displayName);
    }
  }

  public hasAssessment(uid: any) {
    return this._resultByUid.has(uid);
  }

  /**
   * data => {
   * "charts" => [{
   *   "assessment: "dass-21", "scale": "88...."
   *  }]
   * }
   * @param data 
   * @param results 
   * @param variables 
   */
  public setReportData(data: any, results: AssessmentResult[], variables: Variable[]) {
    if (!data || !results) {
      return;
    }

    this._title = data.title;
    this._description = data.description;

    // if there are multiples... this uses the last instance they took...
    results.forEach(rs => {
      this._resultByUid.set(rs.assessment.uid, rs);
    });

    if (data.sections) {
      this._sections = data.sections;
    }
    else {
      this._sections = [];
    }
  }

  public shouldPrintBreak(index: number) {
    // since index is 0 based the the user scales per page is 1 based we convert.
    return ((index + 1) == this._scales_per_page);
  }

  get ScalesPerPage() {
    return this._scales_per_page;
  }

  get ScaleResults() {
    return this._scaleResults;
  }
  get AssessmentResult() {
    return this._assessmentResult;
  }

  get title() {
    return this._title;
  }

  get description() {
    return this._description;
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/scale-results-summary/scale-results-summary.component.ts